import { gql } from "@stadium/services/apollo-client";

export const fetchBaseTotalProducts = gql`
  query getTotalBaseProducts(
    $storeId: Int!
    $countryCode: String!
    $currentStoreId: Int
    $taxonIds: [Int!]
    $budget: Int
    $dietaryRestrictionIds: [Int!]
    $page: Int
    $priceKeys: [String!]
    $color: [String!]
    $size: [String!]
    $perPage: Int
    $sortBy: String
    $searchQuery: String
    $productId: Int
    $skipAggregations: Boolean
    $skipWarehouse: Boolean
    $includeInactiveProducts: Boolean
    $includeInactiveVariants: Boolean
    $onlyInactiveProducts: Boolean = false
    $storeUpcharge: Float
    $withSwag: Boolean
    $designedStoreIds: [Int!]
    $preFilterProductIds: [Int!]
    $withOutOfStock: Boolean
    $brandIds: [Int!]
    $storeUpdatedAt: String
    $noCache: Boolean
    $globalZone: Boolean
    $showVariantsAsProducts: Boolean
    $intent: String
    $catalogStoreId: Int
    $menuId: Int
    $excludeByoProducts: Boolean
    $excludeTierPricing: Boolean
    $bulkAvailable: Boolean
    $shippedFromStadium: Boolean
    $printTypes: [String!]
  ) @api(name: "search") {
    baseSearch(
      storeId: $storeId
      countryCode: $countryCode
      taxonIds: $taxonIds
      currentStoreId: $currentStoreId
      budget: $budget
      dietaryRestrictionIds: $dietaryRestrictionIds
      page: $page
      brandIds: $brandIds
      priceKeys: $priceKeys
      color: $color
      size: $size
      perPage: $perPage
      sortBy: $sortBy
      searchQuery: $searchQuery
      productId: $productId
      skipAggregations: $skipAggregations
      skipWarehouse: $skipWarehouse
      includeInactiveProducts: $includeInactiveProducts
      includeInactiveVariants: $includeInactiveVariants
      onlyInactiveProducts: $onlyInactiveProducts
      storeUpcharge: $storeUpcharge
      withSwag: $withSwag
      designedStoreIds: $designedStoreIds
      preFilterProductIds: $preFilterProductIds
      withOutOfStock: $withOutOfStock
      storeUpdatedAt: $storeUpdatedAt
      noCache: $noCache
      globalZone: $globalZone
      showVariantsAsProducts: $showVariantsAsProducts
      intent: $intent
      catalogStoreId: $catalogStoreId
      menuId: $menuId
      excludeByoProducts: $excludeByoProducts
      excludeTierPricing: $excludeTierPricing
      bulkAvailable: $bulkAvailable
      shippedFromStadium: $shippedFromStadium
      printTypes: $printTypes
    ) {
      total
    }
  }
`;
